const $ = jQuery.noConflict();

const Forms = () => {
  const hubspotForm = document.querySelectorAll('.hbspt-form form.hs-custom-style');

  //Remove hubspot's styling from forms
  if (hubspotForm) {
    hubspotForm.forEach(function(form) {
      form.classList.remove('hs-custom-style');
    });
  }
  
  //Two-page CTA form
  $('#page-hero-cta-page-toggle').on( "click", function(e){
    e.preventDefault();
	$(this).closest('div').hide();
	$(this).closest('div').next().show();
  });
};

export default Forms;